import type { EntityConfig } from "../hooks/useEntity";

export const collaborationMessageEntityConfig: EntityConfig = {
  name: "CollaborationMessage",
  orderBy: "sentAt DESC, created_at DESC",
  properties: {
    documentId: { type: "integer", description: "Associated document ID" },
    userId: { type: "integer", description: "Sender user ID" },
    body: { type: "string", description: "Chat message content" },
    sentAt: { type: "string", format: "date", description: "Timestamp when the message was sent" },
  },
  required: ["documentId", "userId", "body"],
};
